var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (result) {
buf.push("<img" + (jade.attr("src", result.imageUrl(), true, true)) + " width=\"70\" height=\"70\"" + (jade.attr("alt", result.get('title'), true, true)) + " onerror=\"this.style.display=&quot;none&quot;;\">");}.call(this,"result" in locals_for_with?locals_for_with.result:typeof result!=="undefined"?result:undefined));;return buf.join("");
};
module.exports = template;